import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit  {
  public router: string=''; 
  constructor() {}

  ngOnInit() {
    //this.load();
  }
 
  mapLatitude:any;
  mapLongitude:any;

  // Close map model
  closeMapModel() {
    const modelDiv = document.getElementById('myMapModel');
    const modelBackdropDiv = document.getElementById('modalBackdrop');
    if (modelDiv != null && modelBackdropDiv != null) {
      modelDiv.style.display = 'none';
      modelDiv.classList.remove("show");
      modelBackdropDiv.classList.remove("show");
    }
  }

  load() {
    this.mapLatitude = document.getElementById('mapLatitude')?.innerText;
    this.mapLongitude = document.getElementById('mapLongitude')?.innerText;
  }
}